import * as React from "react";
import { Layout } from "../layout/layout";

export interface SupplierPortalProps {
  className?: string;
}

export const SupplierPortal: React.FC<SupplierPortalProps> = ({ className = "" }) => {
  return (
    <Layout>
      <div className={`${className} py-8`}>
        {/* Supplier portal content here */}
      </div>
    </Layout>
  );
};

export default SupplierPortal;
